import { z } from 'zod'

const UserPhotoSchema = z.object({
  avatar: z.string().nullable(),
})

const CompanyPhotoSchema = z.object({
  medium: z.string().nullable(),
  small: z.string().nullable(),
})

const UserProfileSchema = z.object({
  name: z.string(),
  phone_number: z.string(),
  photo: UserPhotoSchema,
  company_photo: CompanyPhotoSchema,
})

const UserOptionsSchema = z.object({
  date_format: z.string(),
  distance_units: z.string(),
  temperature_units: z.string(),
})

const NotificationsSchema = z.object({
  enter_no_go_zone: z.boolean(),
  leave_no_go_zone: z.boolean(),
  enter_safe_zone: z.boolean(),
  leave_safe_zone: z.boolean(),
  low_battery: z.boolean(),
  return_time_approaching: z.boolean(),
})

const UserNotificationSchema = z.object({
  owner_notifications: NotificationsSchema,
  customer_notifications: NotificationsSchema,
  via_email: z.boolean(),
  via_sms: z.boolean(),
})

export const AppUserSchema = z.object({
  user_id: z.number(),
  email: z.string().email(),
  is_email_verified: z.boolean(),
  profile: UserProfileSchema,
  options: UserOptionsSchema,
  notifications: UserNotificationSchema,
})

export type AppUser = z.infer<typeof AppUserSchema>
export type UserProfile = z.infer<typeof UserProfileSchema>
export type UserOptions = z.infer<typeof UserOptionsSchema>
export type UserNotification = z.infer<typeof UserNotificationSchema>
export type Notifications = z.infer<typeof NotificationsSchema>

export const UserLoginSchema = z.object({
  email: z.string().email(),
  password: z.string(),
})

export type UserLogin = z.infer<typeof UserLoginSchema>
